import { ProductMetafields } from "~/types";
import ProductCard from "../ProductCard.client";
import { sectionRecommendedProducts, showPriceSaleWithDetailText } from "../../../../setup/settings/__product";

type RecommendedProductsProps =
    {
        featuredProducts: ProductFilterObject[],
        product: ProductMetafields,
        settings: string,
        currency: string
    }

export default function RecommendedProducts({ featuredProducts, product, settings, currency }: RecommendedProductsProps) {
    let featuredCount = 0;
    const shopSettings = settings != null ? JSON.parse(settings) : null;

    return (
        <div className="recommended lg:mt-28 ProductList">
            <h3>{sectionRecommendedProducts.title}</h3>
            {sectionRecommendedProducts.readAll && featuredProducts && featuredProducts?.length > 0 &&
                <a className="recommended-readAll" href={`/collections/${featuredProducts[0]?.brand?.handle}/products`}>{sectionRecommendedProducts.readAllText}</a>
            }
            <div className="grid gap-14 xl:grid-cols-4 lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 my-16 px-4">

                {featuredProducts.map(fp => {
                    if (fp.handle != product.handle && featuredCount < 4) {
                        featuredCount++;
                        return (
                            <a className={`p-4 rounded-lg cursor-pointer select-none hover:opacity-70 ${showPriceSaleWithDetailText.enabled ? "PriceWithText" : ""}`} href={`/products/${fp.handle}`}>
                                <ProductCard product={fp} shopSettings={shopSettings} currency={currency} />
                            </a>)
                    }
                })}
            </div>
        </div>
    )
}